import React from 'react';
import LogoImage from './logo.png';
import { LogoWrapper } from './style';

const Logo = () => {
  return (
    <LogoWrapper>
      <a href="/">
        <img src={LogoImage} alt="logo" width={150} />
      </a>
    </LogoWrapper>
  );
};

export default Logo;
